/**
 * This script will detect if the device is desktop or mobile
 */
export const isMobile = (div) => {
  let $el = window
  let prop = 'innerWidth'
  if (div) {
    $el = document.querySelector(div)
    prop = 'clientWidth'
  }
  if ($el[prop] < 768) {
    return true
  } else {
    return false
  }
}
